import script from "./Item.vue?vue&type=script&setup=true&lang=ts"
export * from "./Item.vue?vue&type=script&setup=true&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=714efd2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714efd2e"]])

export default __exports__